module.exports = __webpack_public_path__ + "a581ad9f5d2f31540ed8f512e86f068b.png";